type Props = {
  className?: string;
  style?: React.CSSProperties;
  isExpanded?: boolean;
};

export const ConstraintsChevronIcon: React.FC<Props> = ({
  className,
  style,
  isExpanded,
}) => {
  return (
    <svg
      className={className}
      style={{
        ...style,
        transform: isExpanded ? "rotate(0deg)" : "rotate(180deg)",
        transition: "transform 0.3s ease",
      }}
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        d="M2.75045 11.0459C2.62147 11.0455 2.49415 11.0167 2.37756 10.9616C2.26096 10.9064 2.15795 10.8263 2.07585 10.7268C1.99374 10.6273 1.93457 10.511 1.90252 10.386C1.87048 10.2611 1.86636 10.1306 1.89045 10.0039C1.92353 9.83445 2.00599 9.67858 2.12745 9.5559L7.33145 4.3049C7.49953 4.13954 7.72567 4.04657 7.96145 4.0459C8.19024 4.04624 8.40958 4.13721 8.57145 4.2989L13.8805 9.5489C14.0454 9.71227 14.1387 9.93449 14.1399 10.1667C14.141 10.3988 14.0498 10.6219 13.8865 10.7869C13.7231 10.9519 13.5009 11.0452 13.2687 11.0463C13.0365 11.0474 12.8134 10.9563 12.6485 10.7929L7.95945 6.1579L3.37645 10.7859C3.29475 10.8688 3.19726 10.9346 3.08975 10.9792C2.98224 11.0239 2.86687 11.0465 2.75045 11.0459Z"
        fill="#0133cd"
      />
    </svg>
  );
};
